export function submitForm(formEl?: HTMLFormElement | null) {
  formEl?.dispatchEvent(
    new Event('submit', {
      bubbles: true,
      cancelable: true,
    }),
  )
}
